import { useState, useEffect } from 'react';
import Navbar from '../guide/components/Navbar';
import TokushohoContent from './components/TokushohoContent';
import Footer from '../home/components/Footer';

export default function TokushohoPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <TokushohoContent />
      <Footer />
    </div>
  );
}
